<div id="footer" class='bg-light'>
  <div>
    Copyright 2020 - Iconic Air, Inc. All Rights Reserved.
  </div>
</div>